import { useCallback, useEffect, useState } from 'react';
import { workflowService } from '../api/workflowService';
import type { ChainTreeNode, WorkflowInstanceDetail } from '../api/types';

export const useWorkflowInstance = (instanceId?: string) => {
  const [data, setData] = useState<WorkflowInstanceDetail | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetch = useCallback(async () => {
    if (!instanceId) { setData(null); return; }
    setLoading(true);
    setError(null);
    try {
      setData(await workflowService.getInstance(instanceId));
    } catch (err) {
      setError(err as Error);
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [instanceId]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { data, loading, error, refetch: fetch };
};

export const useWorkflowChain = (rootInstanceId?: string) => {
  const [data, setData] = useState<ChainTreeNode | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetch = useCallback(async () => {
    if (!rootInstanceId) { setData(null); return; }
    setLoading(true);
    setError(null);
    try {
      setData(await workflowService.chainTree(rootInstanceId));
    } catch (err) {
      setError(err as Error);
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [rootInstanceId]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { data, loading, error, refetch: fetch };
};
